import { EventengineStopStackTracesService_stopStackTraceServiceGetEntity } from '@festina/moneyout-general-types/moneyout/hooks/EventengineStopStackTracesService_stopStackTraceServiceGetEntity'

export const useFetchMoneyOutStackTrace =
  EventengineStopStackTracesService_stopStackTraceServiceGetEntity.useSuspenseQuery
